import React from 'react';
import { ItemWorkFlow } from './ItemWorkFlow';
import formatDateString from '../../../utils/formatted-date';
import { DefaultCustomerData, WizardDocConversation } from '../../../types/api-types';
import { InternalArtStates } from '../../../types/art-status';

//Styles
import styles from './user-workflow.module.css';

interface UserWorkFlowProps {
  designId: string;
  designStatus: InternalArtStates;
  conversations: WizardDocConversation[];
  allowThreads: boolean;
  isAdminMode: boolean;
  archived: boolean;
  designCustomerId: string;
  refreshNotes: () => Promise<void>;
  defaultCustomerData: DefaultCustomerData;
  refreshSewFilePrice: () => Promise<void>;
  refreshArtFeePrice: () => Promise<void>;
}

const UserWorkFlow: React.FC<UserWorkFlowProps> = ({ conversations, designId, designStatus, isAdminMode, archived, designCustomerId, refreshNotes, defaultCustomerData, refreshSewFilePrice, refreshArtFeePrice }) => {
  const [showStatusChanges, setShowStatusChanges] = React.useState(false);
  const { sortedConversations, statusChanges } = React.useMemo(() => {
    setShowStatusChanges(false);
    const allConversations = conversations.slice().sort((a, b) => {
      const dateA = new Date(a.updateDate || a.createdDate || 0).getTime();
      const dateB = new Date(b.updateDate || b.createdDate || 0).getTime();
      return dateB - dateA;
    });
    const sortedConversations = allConversations.filter(conversation => conversation.userDataToken != "STATUSCHANGEREPORT");
    const statusChanges = allConversations.filter(conversation => conversation.userDataToken == "STATUSCHANGEREPORT");
    return { sortedConversations, statusChanges };
  }, [conversations]);

  return (
    <>
      <div>
        <ItemWorkFlow
          designId={designId}
          designStatus={designStatus}
          activeConversationId={1}
          adminMode={isAdminMode}
          archived={archived}
          refreshNotes={refreshNotes}
          defaultCustomerData={defaultCustomerData}
          refreshSewFilePrice={refreshSewFilePrice}
          refreshArtFeePrice={refreshArtFeePrice}
        />
        <div className={styles.wrapper}>
          <div className={styles.buttonsContainer}>
            <button className={showStatusChanges ? undefined : styles.activeButton} onClick={() => setShowStatusChanges(false)}>Communication History</button>
            {statusChanges.length > 0 && <button className={showStatusChanges ? styles.activeButton : undefined } onClick={() => setShowStatusChanges(true)}>Status Changes</button>}
          </div>
          {showStatusChanges && statusChanges.map((conversation) => (
            <ConversationItem key={conversation.id} conversation={conversation} designCustomerId={designCustomerId} isAdminMode={isAdminMode} />
          ))}
          {!showStatusChanges && sortedConversations.map((conversation) => (
            <ConversationItem key={conversation.id} conversation={conversation} designCustomerId={designCustomerId} isAdminMode={isAdminMode} />
          ))}
        </div>
      </div>
    </>
  );
};

type ConversationItemProps = {
  conversation: WizardDocConversation;
  designCustomerId: string;
  isAdminMode: boolean;
};

const ConversationItem: React.FC<ConversationItemProps> = ({ conversation, designCustomerId, isAdminMode }) => {
  const conversationData = JSON.parse(conversation.message);
  const isStatusChangeReport = conversation?.userDataToken == "STATUSCHANGEREPORT";
  const userDataToken = isStatusChangeReport ? "Status change" : isAdminMode ? (conversation?.userDataToken == designCustomerId ? 'Customer' : 'Art team') : (conversation?.userDataToken == designCustomerId ? 'You' : 'Art team')
  const lastUpdate = conversation.createdDate || conversation.updateDate;
  const formattedDate = lastUpdate ? formatDateString({ dateString: lastUpdate }) : "";

  return (
    <div className={styles.container}>
      <span className={`${styles.column} ${isStatusChangeReport ? styles.column1Status : styles.column1}`}>
        {userDataToken}:
      </span>
      <span className={`${styles.column} ${isStatusChangeReport ? styles.column2Status : styles.column2}`}>
        {conversationData.message}
      </span>
      <span className={`${styles.column} ${styles.column3}`}>
        {formattedDate}
      </span>
    </div>
  );
};

export default UserWorkFlow;